import Glide, {
  Autoplay,
  Anchors,
  Controls,
  Images,
  Swipe,
  Breakpoints, GlideOptions, GlideMountOptions
} from '@glidejs/glide/dist/glide.modular.esm';

/* AutoHeight calculation method */
function glideHandleHeight(parent?: HTMLElement): void {
  if (!parent) {
    return;
  }

  parent = parent || document;

  const activeSlide: HTMLElement | null = parent.querySelector('.glide__slide--active');
  const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;

  const glideTrack: HTMLElement | null = parent.querySelector('.glide__track');
  const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;

  if (glideTrack !== null && activeSlideHeight !== glideTrackHeight) {
    glideTrack.style.height = `${activeSlideHeight}px`;
  }
}

function init(): void {
  const sliders: NodeListOf<HTMLElement> = document.querySelectorAll('.glide-slider');
  sliders.forEach(sliderNode => {
    new Glide(sliderNode, {
      type: 'slider',
      startAt: 0,
      focusAt: 0,
      perView: 1,
      rewind: true,
      autoplay: 20000,
      hoverpause: true
    })
      .mount({
        Controls,
        Autoplay,
        Images,
        Swipe
      });
  });

  /* Partners / Known From */
  const partners: NodeListOf<HTMLElement> = document.querySelectorAll('.glide-partners');
  partners.forEach(partnerNode => {
    new Glide(partnerNode, {
      type: 'carousel',
      focusAt: 'center',
      autoplay: 3000,
      hoverpause: true,
      perView: 7,
      breakpoints: {
        1200: {
          perView: 7
        },
        768: {
          perView: 5
        },
        476: {
          perView: 3
        }
      },
      animationTimingFunc: 'ease-in-out'
    })
      .mount({
        Anchors,
        Breakpoints,
        Autoplay,
        Images,
        Swipe
      });
  });

  /* Testimonials Sliders */
  const testimonials: NodeListOf<HTMLElement> = document.querySelectorAll('.glide-testimonials');
  testimonials.forEach(testimonialsNode => {
    const testimonialsSlider = new Glide(testimonialsNode, {
      type: 'carousel',
      autoplay: 5000,
      hoverpause: true,
      startAt: 0,
      focusAt: 0,
      perView: 1,
      rewind: true,
    })
      .on('build.after', function () {
        // Automated height on Carousel build
        glideHandleHeight(testimonialsNode);
      })
      .on('run.after', function () {
        // Automated height on Carousel change
        glideHandleHeight(testimonialsNode);
      });

    testimonialsSlider.mount({
      Anchors,
      Controls,
      Autoplay,
      Images,
      Swipe
    });
  });

  /* Photo Sliders */
  const photos = document.querySelectorAll<HTMLElement>('.glide-photos');
  photos.forEach(photoNode => {
    const autoplay = photoNode.hasAttribute('data-autoplay')
      ? Number(photoNode.getAttribute('data-autoplay'))
      : 10000;

    let options: GlideOptions = {
      type: 'slider',
      startAt: 0,
      focusAt: 0,
      perView: 1,
      rewind: true,
    };

    let mountOptions: GlideMountOptions = {
      Anchors,
      Controls,
      Swipe,
    };

    if (autoplay > 0) {
      options = {
        ...options,
        autoplay: autoplay,
        hoverpause: true,
      };

      mountOptions = {
        ...mountOptions,
        Autoplay,
      };
    }

    new Glide(photoNode, options)
      .on('build.after', function () {
        // Automated height on Carousel build
        glideHandleHeight(photoNode);
      })
      .on('run.after', function () {
        // Automated height on Carousel change
        glideHandleHeight(photoNode);
      })
      .mount(mountOptions);
  });
}

window.addEventListener('load', init, false);
